import React from "react";

const baseProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 64 64",
};

export const DressCodeIcon = ({ className = "" }) => (
  <svg {...baseProps} className={className}>
    {/* Bride */}
    <circle cx="22" cy="14" r="4" />
    <path d="M22 18v4" />
    <path d="M16 25c0-2 2.5-3 6-3s6 1 6 3" />
    <path d="M14 56l4-31h8l4 31z" />
    <path d="M16 36c2-1 4-1 6 0s4 1 6 0" />
    {/* Groom */}
    <circle cx="44" cy="14" r="4" />
    <path d="M44 18v3" />
    <path d="M38 25c0-2 2.5-3 6-3s6 1 6 3" />
    <path d="M38 56V28l6-7 6 7v28" />
    <path d="M44 21l-2 6 2 4 2-4-2-6z" />
    <path d="M38 32h12" />
  </svg>
);

export const RegistryIcon = ({ className = "" }) => (
  <svg {...baseProps} className={className}>
    <path d="M10 26h44v28H10z" />
    <path d="M8 20h48v6H8z" />
    <path d="M32 20v34" />
    <path d="M32 20c-4-6-12-6-12-1 0 3 4 5 12 5" />
    <path d="M32 20c4-6 12-6 12-1 0 3-4 5-12 5" />
  </svg>
);

export const HotelIcon = ({ className = "" }) => (
  <svg {...baseProps} className={className}>
    <path d="M6 54V18l26-8 26 8v36" />
    <path d="M6 54h52" />
    <path d="M14 26h6v6h-6zM26 26h6v6h-6zM38 26h6v6h-6z" />
    <path d="M14 38h6v6h-6zM38 38h6v6h-6z" />
    <path d="M26 54v-16h6v16" />
    <path d="M32 6v4" />
    <path d="M28 10h8" />
  </svg>
);

export const AdultsOnlyIcon = ({ className = "" }) => (
  <svg {...baseProps} className={className}>
    {/* Left flute tilted right - clinking */}
    <path d="M14 8 L22 30 A5 5 0 0 0 32 30 L26 8 Z" />
    <line x1="27" y1="30" x2="34" y2="52" />
    <line x1="30" y1="52" x2="38" y2="52" />
    {/* Right flute tilted left - clinking */}
    <path d="M50 8 L42 30 A5 5 0 0 1 32 30 L38 8 Z" />
    <line x1="37" y1="30" x2="30" y2="52" />
    <line x1="26" y1="52" x2="34" y2="52" />
    {/* Rim tops */}
    <line x1="14" y1="8" x2="26" y2="8" />
    <line x1="38" y1="8" x2="50" y2="8" />
    {/* Sparkles at clink point */}
    <path d="M32 14l1 2 2 1-2 1-1 2-1-2-2-1 2-1z" />
  </svg>
);

export default { DressCodeIcon, RegistryIcon, HotelIcon, AdultsOnlyIcon };
